module.exports = __webpack_public_path__ + "static/media/campeonato_02.9ba70ea1.jpg";